<script>
  import AssetDropdownOption from "../AssetSelect/AssetDropdownOption.svelte";

  export let value;
  export let options = [];
  export let otherOptionsOpen = false;
  export let rounded = false;

  const optionBaseClasses = "relative text-sm font-semibold text-neutral-1100 flex items-center gap-x-1.5 border px-2 py-2.5 hover:bg-primary-100 hover:border-gray-600 cursor-pointer"

  const roundedClass = rounded ? "rounded-[100px]" : "rounded";
  
  const optionStyles = isSelected => {
    const selectedStyles = isSelected ? "bg-white border-r-0 border-gray-500 border-opacity-75 rounded-l-lg rounded-r-none" : "bg-white border-gray-500 border-opacity-75";
    return roundedClass + " " + optionBaseClasses + " " + selectedStyles;
  }

  $: optionSelected = options.map(opt => opt.value).includes(value);

  $: selectedOption = options.find(o => o.value === value);

  $: optionsVisibilityClasses = otherOptionsOpen ? "opacity-100" : "opacity-0 pointer-events-none";

  $: wrapperClasses = `${optionsVisibilityClasses} absolute top-11 left-0 bg-white p-2 border border-gray-500 max-h-40 overflow-scroll`;

  const handleClick = v => () => {
    otherOptionsOpen = false;
    value = v;
  }

</script>

<div class="relative">
  <AssetDropdownOption asset={selectedOption} classes={optionStyles(optionSelected)} onClick={() => otherOptionsOpen = !otherOptionsOpen}>
    <svg slot="end" class="ml-auto" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0.412046 0.910734C0.0866095 1.23617 0.0866095 1.76381 0.412046 2.08925L5.41205 7.08925C5.73748 7.41468 6.26512 7.41468 6.59056 7.08925L11.5906 2.08925C11.916 1.76381 11.916 1.23617 11.5906 0.910734C11.2651 0.585297 10.7375 0.585297 10.412 0.910734L6.0013 5.32148L1.59056 0.910734C1.26512 0.585297 0.737483 0.585297 0.412046 0.910734Z" fill="#5B7088"/>
    </svg>
  </AssetDropdownOption>
  
  <!-- List of other coins -->
  <div class={wrapperClasses}>
    {#each options as cryptoOption (cryptoOption)}
      <AssetDropdownOption asset={cryptoOption} classes="text-sm font-semibold text-neutral-1100 flex items-center gap-x-1.5 px-2 py-2.5 hover:bg-primary-100 cursor-pointer bg-white" onClick={handleClick(cryptoOption.value)} />
    {/each}
  </div>
</div>